import { GivelifyIcon } from '@givelify/givelify-ui';
import { GivelifyLegacyColorPalette } from '@givelify/ui';
import {
    styled,
    FormControlLabel,
    IconButton,
    Dialog,
    RadioGroup,
} from '@mui/material';

export const ButtonText = styled('div')(({ theme }) => ({
    paddingLeft: theme.spacing(1),
    fontWeight: 'bold',
}));

export const IconButtonStyled = styled(IconButton)({
    fontSize: '16px',
    borderRadius: '3px',
});

export const Title = styled('h3')(({ theme }) => ({
    paddingLeft: theme.spacing(3),
    fontSize: '16px',
    fontWeight: 'bold',
}));

export const DialogStyled = styled(Dialog)(({ theme }) => ({
    '& .MuiExpansionPanel-root:before': {
        opacity: 0,
    },
    [theme.breakpoints.down('sm')]: {
        '& .MuiDialog-scrollPaper': {
            alignItems: 'flex-end',
        },
        '& .MuiDialog-paperWidthSm': {
            maxWidth: '100%',
            width: '100%',
            margin: 'unset',
            height: 'calc(100vh - 50px)',
        },
    },
}));

export const Divider = styled('hr')({
    border: '2px solid #D7EBF4',
    width: '100%',
    marginBottom: 'unset',
    marginTop: 'unset',
});

export const CheckmarkRadio = styled(FormControlLabel)({
    padding: '12px 24px',
    borderBottom: `1px solid ${GivelifyLegacyColorPalette.grey500}`,
    justifyContent: 'space-between',
    '& .MuiRadio-checked': {
        background: 'hotpink',
    },
    '& .MuiRadio-root': {
        order: 1,
        marginLeft: 'auto',
        padding: 0,
    },
    '&:last-child': {
        borderBottom: 0,
    },
});

export const SelectedLabel = styled('div')({
    background: '#F0F8FD',
});

export const CheckIcon = styled(GivelifyIcon)({
    fontSize: 14,
});

export const RadioGroupStyled = styled(RadioGroup)({
    width: '100%',
});
